module.exports = __webpack_public_path__ + "img/sTwinkleIc_350x350.ee2856e2.jpg";